// extracted by mini-css-extract-plugin
module.exports = {"listSolutionItem":"SolutionItem_listSolutionItem_30hlJ","brandList":"SolutionItem_brandList_YuEWD"};